"use client";
import { useRouteContext } from "@providers/RouteProvider";

import styles from "./Intro.module.scss";
import cx from "classnames";
import Facebook from "@components/common/Icons/Facebook";
import Instagram from "@components/common/Icons/Instagram";
import Github from "@components/common/Icons/Github";
const View = () => {
  const { router } = useRouteContext();
  return (
    <section data-scroll-section className={cx("inner", styles.section)}>
      <div className={styles.box}>
        <label className="h2">Về Tôi</label>
        <p>
          Mình là một nhà phát triển giao diện website. <br />
          Ưu tiên hiện tại của mình là tạo các trang web vừa đơn giản vừa thân
          thiện với người dùng.
        </p>
      </div>
      <div className={styles.box}>
        <label className="h2">Tìm Tôi</label>
        <div className="flex gap-8">
          <div
            className={cx(styles.icon, styles.fb)}
            onClick={() => window.open(router.toUrl("facebook"), "_blank")}
          >
            <Facebook className="cursor-pointer" color="#000" />
          </div>
          <div
            className={cx(styles.icon, styles.ig)}
            onClick={() => window.open(router.toUrl("instagram"), "_blank")}
          >
            <Instagram className="cursor-pointer" color="#000" />
          </div>
          <div
            className={cx(styles.icon, styles.gh)}
            onClick={() => window.open(router.toUrl("github"), "_blank")}
          >
            <Github className="cursor-pointer" color="#000" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default View;
